import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import '@questlabs/react-sdk/dist/style.css';
import DashboardLayout from './components/layout/DashboardLayout';
import Cockpit from './pages/Cockpit';
import PullRequests from './pages/PullRequests';
import Telemetry from './pages/Telemetry';
import Repositories from './pages/Repositories';
import RepositoryDetail from './pages/RepositoryDetail';
import Topology from './pages/Topology';
import AuditLogs from './pages/AuditLogs';
import Settings from './pages/Settings';
import SecOps from './pages/SecOps';
import KnowledgeBase from './pages/KnowledgeBase';
import AgentRegistry from './pages/AgentRegistry';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import { labService } from './services/labService';
import { supabase } from './services/supabaseClient';
import { hydrateUserPermissions } from './lib/auth';

function App() {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    const cookies = document.cookie.split(';');
    let cookieToken = null;
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith('axim_session=')) {
            cookieToken = cookie.substring('axim_session='.length);
            break;
        }
    }
    if (cookieToken && !localStorage.getItem('axim_internal_key')) {
        localStorage.setItem('axim_internal_key', cookieToken);
    }
  }, []);


  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'TOKEN_REFRESHED') {
        // Preserve active components like PromptTerminal by not clearing session state to undefined during refresh
        if (session) {
           setSession(session);
        }
        return;
      }
      setSession(session);
    });

    return () => {
      labService.disconnectRealtime();
      subscription.unsubscribe();
    };
  }, []);

  if (session === undefined) {
    return <div className="flex h-screen items-center justify-center bg-slate-900 text-white">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={!session ? <Login /> : <Navigate to="/" />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        <Route path="/" element={session ? <DashboardLayout /> : <Navigate to="/login" />}>
          <Route index element={<Cockpit />} />
          <Route path="prs" element={<PullRequests />} />
          <Route path="repositories" element={<Repositories />} />
          <Route path="repositories/:id" element={<RepositoryDetail />} />
          <Route path="knowledge" element={<KnowledgeBase />} />
          <Route path="agents" element={<AgentRegistry />} />
          <Route path="secops" element={<SecOps />} />
          <Route path="topology" element={<Topology />} />
          <Route path="telemetry" element={<Telemetry />} />
          <Route path="audit" element={<AuditLogs />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
